import Swal from 'sweetalert2';

export const alertError = (title, message) => { 
    Swal.fire({
        icon: 'error',
        title: title,
        text: message,
        // footer: '<a href="">Why do I have this issue?</a>'
      })
}